import { Custom } from "components";
import { Stack } from "@mui/material";
import { useApp, useTheme } from "contexts";

export type ForgotPasswordType = {
  email: string;
};

type Props = {
  values: ForgotPasswordType;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Fields = ({ values, onChange }: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();

  return (
    <>
      <Custom.TextField
        type="email"
        name="email"
        required
        onChange={onChange}
        placeholder={t.placeholder.email}
        label={t.label.email}
        value={values.email}
      />
    </>
  );
};
